<template>
  <div class="project-pipeline">
    <div v-if="dataLenth > 0">
      <div v-for="(children, key) in data" :key="key" class="mb10">
        <div class="mb5 ft-blue">{{ key }} （{{ (children && children.length) || 0 }}）</div>
        <div v-for="(child, _index) in children" :key="_index" class="pipeline-table flex-row">
          <span v-for="val in fields" :key="val" :title="child[val]" class="pipeline-cell col-1">
            <span v-if="Array.isArray(child[val])"> {{ (child[val] && child[val].toString()) || '--' }} </span>
            <span v-else>{{ child[val] || '--' }}</span>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="center">暂无数据</div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['姓名', '性别', '公司', '部门', '目前职位', '手机', '地域', '职能模块'],
    }
  },
  computed: {
    dataLenth() {
      let length = 0
      const data = this.data
      const keys = Object.keys(data)
      keys.map(k => {
        length += data[k].length
      })
      return length
    },
  },
}
</script>

<style scoped>
.project-pipeline {
  max-width: 802px;
  min-width: 100px;
  min-height: 50px;
  max-height: 800px;
  border: 1px solid #eaeefb;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  overflow: auto;
}
.pipeline-table {
  /* border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5; */
}
.pipeline-cell {
  min-width: 100px;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px 5px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
.center {
  text-align: center;
  line-height: 48px;
}
</style>
